import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  height: 56px;
  width: 100%;
  max-width: 360px;
  &:focus-within::after {
    content: '';
    position: absolute;
    top: 0px;
    height: 56px;
    left: 0px;
    width: 2px;
    background: var(--primary-color);
    box-shadow: 0px 0px 10px rgba(0, 102, 255, 0.35);
    border-radius: 2px 0px 0px 2px;
  }
`;

const Select = styled.select`
  height: 100%;
  width: 100%;
  background: var(--matt-bg-color);
  border-radius: 2px;
  color: var(--primary-text-color);
  font-size: 12px;
  padding: 20px 16px;
  appearance: none;
  &:focus {
    box-shadow: 0px 0px 30px 10px rgba(0, 102, 255, 0.1);
    border-width: 0px;
    outline: unset;
  }
  &:disabled {
    color: var(--gray-text-color);
    background: var(--matt-bg-color);
    backdrop-filter: unset;
  }
`;

const TriangleWrapper = styled.div`
  position: absolute;
  height: 56px;
  right: 20px;
  pointer-events: none;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
`;

export type SelectOption = {
  label: string;
  value: string | number | readonly string[] | undefined;
};

const StyledSelect = (props: {
  options: SelectOption[];
  onChange: (option: SelectOption) => void;
  initialValue?: string | number | readonly string[] | undefined;
  className?: string;
}): JSX.Element => {
  const [selected, setSelected] = useState<SelectOption | undefined>(
    props.options.find((o) => o.value === props.initialValue) || props.options[0],
  );

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedOption = props.options.find(
      (o) => o.value?.toString() === event.currentTarget.value,
    );
    setSelected(selectedOption);

    if (selectedOption) {
      props.onChange(selectedOption);
    }
  };
  return (
    <Wrapper className={props.className}>
      <Select id="logout-time" value={selected?.value} onChange={handleOnChange}>
        {props.options.map((option: SelectOption, index: number) => (
          <option className="ml-3" key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <TriangleWrapper>
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.42941 0.428571C7.42941 0.194196 7.23521 0 7.00084 0H1.00084C0.766462 0 0.572266 0.194196 0.572266 0.428571C0.572266 0.542411 0.619141 0.649553 0.699498 0.729911L3.6995 3.72991C3.77986 3.81027 3.887 3.85714 4.00084 3.85714C4.11468 3.85714 4.22182 3.81027 4.30218 3.72991L7.30218 0.729911C7.38253 0.649553 7.42941 0.542411 7.42941 0.428571Z"
            fill="white"
          />
        </svg>
      </TriangleWrapper>
    </Wrapper>
  );
};

export default StyledSelect;
